import { render } from "./paySuccess.vue?vue&type=template&id=0be9dc56&scoped=true"
import script from "./paySuccess.vue?vue&type=script&lang=js"
export * from "./paySuccess.vue?vue&type=script&lang=js"

import "./paySuccess.vue?vue&type=style&index=0&id=0be9dc56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be9dc56"]])

export default __exports__